import { Shield } from "lucide-react";

export default function Header({ katlasStatus }) {
  const statusColor =
    katlasStatus?.status === "active"
      ? "bg-emerald-500/15 text-emerald-400 border-emerald-500/30"
      : katlasStatus?.status === "unconfigured"
      ? "bg-amber-500/15 text-amber-400 border-amber-500/30"
      : "bg-zinc-800 text-zinc-400 border-zinc-700";

  const statusLabel =
    katlasStatus?.status === "active"
      ? "KATLAS ACTIVE"
      : katlasStatus?.status === "unconfigured"
      ? "KATLAS UNCONFIGURED"
      : katlasStatus
      ? "KATLAS CHECKING"
      : "KATLAS";

  return (
    <header
      data-testid="app-header"
      className="h-14 border-b border-zinc-800 bg-zinc-950 flex items-center justify-between px-4 md:px-6"
    >
      <div className="flex items-center gap-3">
        <Shield className="h-5 w-5 text-blue-500" strokeWidth={1.5} />
        <span className="text-sm font-semibold tracking-tight text-zinc-50">
          TeardownCierge
        </span>
        <span className="text-[10px] uppercase tracking-widest text-zinc-600 hidden sm:inline">
          Governed Technical Review
        </span>
      </div>
      <div
        data-testid="katlas-status-pill"
        className={`px-3 py-1 text-[10px] uppercase tracking-widest font-mono font-semibold border ${statusColor}`}
      >
        {statusLabel}
      </div>
    </header>
  );
}
